import { render, staticRenderFns } from "./ManageRolesModal.vue?vue&type=template&id=35d4bcc6&scoped=true&"
import script from "./ManageRolesModal.vue?vue&type=script&lang=js&"
export * from "./ManageRolesModal.vue?vue&type=script&lang=js&"
import style0 from "./ManageRolesModal.vue?vue&type=style&index=0&id=35d4bcc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d4bcc6",
  null
  
)

export default component.exports